import { useNavigate, useLocation } from "react-router-dom";
import { Home, ArrowLeft, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";

/**
 * 404 page rendered when no route matches.
 * - Authenticated users see a friendly page with "Back" / "Home" buttons.
 * - Unauthenticated users are redirected to /login (handled by route config).
 */
export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "var(--bg-primary, #0b0811)", color: "var(--text-primary, #fff)" }}
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-[#f7c935]/10 text-[#f7c935] flex items-center justify-center">
          <AlertTriangle className="w-8 h-8" />
        </div>
        <h1 className="text-5xl font-black tracking-tighter mb-3" data-testid="not-found-title">
          404
        </h1>
        <p className="text-zinc-400 mb-2 text-lg">Page introuvable</p>
        <p className="text-zinc-500 text-sm mb-8 break-all">
          <code className="bg-white/5 px-2 py-0.5 rounded">{location.pathname}</code> n'existe pas
          {user ? " ou n'est pas accessible avec votre rôle." : "."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="border-white/10 text-white hover:bg-white/5"
            data-testid="not-found-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" /> Retour
          </Button>
          <Button
            onClick={() => navigate(user ? "/dashboard" : "/login")}
            className="bg-[#f7c935] text-[#14101c] hover:bg-[#e6b825] font-bold"
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4 mr-2" />
            {user ? "Tableau de bord" : "Connexion"}
          </Button>
        </div>
      </div>
    </div>
  );
}
